import React from 'react';
import PropTypes from 'prop-types';

import PaymentSettingsContext from './PaymentSettingsContext';

import usePaymentSettings from 'queries/PaymentSettings/usePaymentSettings';

const PaymentSettingsProvider = ({ children }) => {
	const { data: settings, isLoading, isError } = usePaymentSettings();

	const isLoaded = !!settings;

	return (
		<PaymentSettingsContext.Provider
			value={{
				settings,
				isLoading,
				isError,
				isLoaded
			}}
		>
			{children}
		</PaymentSettingsContext.Provider>
	);
};

PaymentSettingsProvider.propTypes = {
	children: PropTypes.node
};

export default PaymentSettingsProvider;
